import { Components } from "appworks/components/components";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { AutoplayService } from "slotworks/services/autoplay/autoplay-service";
import { RequestFreespinState } from "slotworks/state-machine/standard/states/request-freespin-state";

export class GameiomRequestFreespinState extends RequestFreespinState {
    public onEnter(): void {
        gameWrapper.setBusy();
        super.onEnter();
    }

    // Let the wrapper take over
    public error(): void {
        uiFlags.set(UIFlag.PROMPT, true);
        gameWrapper.setIdle();
        gameWrapper.disableFeatureMode();

        Components.get(MatrixComponent).reset();
        Services.get(AutoplayService).stop();
    }
}
